export default __webpack_public_path__ + "static/media/KidWithMother.9e2dfd69c07c6328aad91bb246420924.webp";